import { Trash2Icon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

interface ResourceDeleteButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

/**
 * Delete in a developer-settings side panel, always the last item, below the last field. It
 * opens the item's confirmation; the panel's footer keeps Save and Cancel.
 */
export const ResourceDeleteButton = ({ onClick, disabled }: ResourceDeleteButtonProps) => {
  const { t } = useTranslation();

  return (
    <div className="pt-2">
      {/* -ml-2 lines the icon up with the fields' left edge, past the ghost button's padding. */}
      <Button
        type="button"
        variant="destructive-ghost"
        size="sm"
        className="-ml-2"
        onClick={onClick}
        disabled={disabled}
      >
        <Trash2Icon aria-hidden="true" />
        {t('common.delete')}
      </Button>
    </div>
  );
};
